/**
 * @description 接口
 */
import axios from 'axios'
import * as dd from 'dingtalk-jsapi'
let HOST = process.env.VUE_APP_API_HOST || '' // 开发环境
if (process.env.NODE_ENV === 'production') {
  HOST = '/mobile' // 钉钉环境
} else {
  HOST = process.env.VUE_APP_API_HOST || ''
}
const axiosConfig = {
  method: 'post',
  // 基础url前缀
  baseURL: '',
  // 请求头信息
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  },
  // 参数
  data: {},

  // 设置超时时间
  timeout: 10000,
  // 携带凭证
  withCredentials: true,
  // 返回数据类型
  responseType: 'json'
}
axios.interceptors.request.use(function (config) {
  config.headers.dingToken = window.dingToken
  config.headers.loginId = window.loginId
  // config.headers.dingToken = $cookies.get('dingToken')
  // config.headers.loginId = $cookies.get('loginId')

  return config
})
const API = {
  // 示例
  test: HOST + '/test',
  getDataFromInterface (url, params = {}, options) {
    const configs = {
      ...axiosConfig,
      url,
      data: params,
      ...options
    }
    return new Promise((resolve, reject) => {
      axios(configs)
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          if (err.response.status == '403') {
            // var r = confirm(err.message || '登录已过期，请重新进入此应用')
            // if (r === true) {
            //   dd.ready(function () {
            //     dd.biz.navigation.close()
            //   })
            // } else {
            //   dd.ready(function () {
            //     dd.biz.navigation.close()
            //   })
            // }
            dd.ready(function () {
              dd.device.notification.toast({
                icon: '', // icon样式，不同客户端参数不同，请参考参数说明
                text: err.message || '登录已过期，请重新进入此应用', // 提示信息
                duration: '5s', // 显示持续时间，单位秒，默认按系统规范[android只有两种(<=2s >2s)]
                // onSuccess: function (result) {
                //   dd.biz.navigation.close()
                //   /* {} */
                // },
                onFail: function (err) { dd.biz.navigation.close() }
              })
            })
          }

          reject(err)
        })
    })
  },
  getUserCropId: HOST + 'dd/getDingInfo',
  getUserDingToken: HOST + 'dd/getLoginIdAndToken',
  getKeyInfo: HOST + 'getKeyInfo', // 获取点击问号的预警信息
  getAuth: HOST + 'dd/getAuth', // 获取用户权限
  insertPageAccess: HOST + 'dd/insertPageAccess', // 记录用户访问记录
  getUserInfo: HOST + 'dd/getUserInfo',
  getServerVersion: HOST + 'dd/getServerVersion',
  finance: {
    getZcsrNewDate: HOST + 'fi/profitUpdDate', // 获取整车收入，品牌利润，广宣费的最新时间
    getZcsrCardData: HOST + 'fi/profitStatis', // 获取整车收入和品牌利润卡信息
    getGxfCardData: HOST + 'fi/publicityStatis', // 获取广宣费卡片数据
    getZcjbNewDate: HOST + 'fi/carReducedUpdDate', // 获取直材降本最新的时间
    getZcjbCardData: HOST + 'fi/carReducedStatis', // 获取直材降本卡片数据
    getJlrNewDate: HOST + 'fi/netProfitUpdDate', // 获取净利润最新的时间
    getJlrCardData: HOST + 'fi/netProfitStatis', // 获取净利润卡片数据
    getJyhdNewDate: HOST + 'fi/operationCashUpdDate', // 获取净利润最新的时间
    getJyhdCardData: HOST + 'fi/operationCashStatis', // 获取净利润卡片数据
    getYfjsNewDate: HOST + 'fi/rdInputUpdDate', // 获取研发技术最新的时间
    getYfjsCardData: HOST + 'fi/rdInputStatis', // 获取研发技术卡片数据
    getYfOrgListNewDate: HOST + 'fi/rdInputOrgName', // 获取研发技术单位列表数据
    getZjzzNewDate: HOST + 'fi/assetTurnoverUpdDate', // 获取资金周转最新的时间
    getZjzzCardData: HOST + 'fi/assetTurnoverStatis', // 获取资金周转卡片数据
    getZcsrDetailUpChartData: HOST + 'fi/profitTrade', // 获取整车收入详情页，柱线图数据
    getZcsrDetailMiddleTable: HOST + 'fi/carBrandProfit', // 获取整车收入详情页，中间表格
    getZcsrDetailDownTable: HOST + 'fi/countryProfit', // 获取整车收入详情页，下部表格
    getGxfDetailUpChartData: HOST + 'fi/publicityTrade', // 获取广宣费详情页，趋势图数据
    getGxfDetailTableData: HOST + 'fi/publicityCarBrand', // 获取广宣费详情页，下部表格
    getZcjbDetailUpChartData: HOST + 'fi/carReducedTrade', // 获取直材降本趋势图数据
    getZcjbDetailTableDataBrand: HOST + 'fi/carReducedBrand', // 获取直材降本表格数据，品牌
    getZcjbDetailTableDataCx: HOST + 'fi/carReducedSeries', // 获取直材降本表格数据，车系
    getJlrDetailUpChartData: HOST + 'fi/netProfitTrade', // 获取净利润上部柱图数据
    getJyhdDetailUpChartData: HOST + 'fi/operationCashTrade', // 获取经营活动详情页 趋势图数据
    getYftrDetailUpChartData: HOST + 'fi/rdInputTrade', // 获取研发投入详情页 趋势图数据
    getYftrDetailDownTable: HOST + 'fi/rdInputDetail', // 获取研发投入详情页 表格数据
    getZjzzDetailUpChartData: HOST + 'fi/assetTurnoverTrade' // 获取资金周转详情页 趋势图
  },
  // 生产模块接口
  market: {
    getCompanyOverView: HOST + 'productApi/companyOverView', // 获取年、月计划与实际产量信息
    getProductCountByMonth: HOST + 'productApi/getProductCountByMonth', // 产量趋势-当年每月信息
    getBaseProductCount: HOST + 'productApi/getBaseProductCount', // 产量趋势-当年每月信息
    getBrandProductCount: HOST + 'productApi/getBrandProductCount', // 品牌-各品牌年月日产量明细数据
    getFactoryProductCountByBase:
      HOST + 'productApi/getFactoryProductCountByBase', // 根据基地获取各工厂当年每月产量数据
    getFactoryDetailCountByBase:
      HOST + 'productApi/getFactoryDetailCountByBase', // 根据基地获取各工厂产量数据
    getCarDetailCountByFactory: HOST + 'productApi/getCarDetailCountByFactory', // 详情
    getProductCountByBrand: HOST + 'productApi/getProductCountByBrand', // 根据品牌获取当年每月产量数据
    getProductDetailCountByBrand:
      HOST + 'productApi/getProductDetailCountByBrand' // 根据品牌获取车型明细产量数据
  },
  // 营销模块接口
  sale: {
    getSaleNewDate: HOST + 'sl/saleUpdDate', // 获取营销页面最新的时间
    getSaleUpData: HOST + 'sl/saleStatis', // 获取营销页面销售，批售，国内库存数据 //海外营销三级页面 获取合计单行的明细
    getSaleKxbOutData: HOST + 'sl/saleGlobalCountry', // 国外库存数据
    getSaleKcRoseData: HOST + 'sl/reservoirType', // 获取国内库龄结构
    getSaleGlobalCountryData: HOST + 'sl/saleGlobalCountry', // 获取海外国家销量、批发量、库存信息明细
    getSzlNewDate: HOST + 'sl/tradeUpdDate', // 获取市占率最新的时间
    getSzlBrandData: HOST + 'sl/tradeCarBrand', // 获取国内市占率的数据
    getSzlCountryData: HOST + 'sl/tradeAbCountry', // 获取海外市占率的数据
    getSaleTradeData: HOST + 'sl/saleTrade', // 获取销量、批发量、库存趋势信息  //海外库存二级 趋势
    getKljgLeftData: HOST + 'sl/saleCarBrand', // 中国库销比二级页面，中间库存结构左边数据  //海外库存二级 库存量详情
    getKljgRightData: HOST + 'sl/reservoirType', // 中国库销比二级页面，中间库存结构右边数据
    getZkcCxTableData: HOST + 'sl/saleCarSeries', // 中国库销比二级页面，总库存车系表格  //海外营销三级页面 获取车系除合计的明细 //海外库存 二级页面 车系明细
    getJxsSfTableData: HOST + 'sl/saleProvince', // 中国库销比二级页面，经销商省份表格
    getOtherCountrySaleData: HOST + 'sl/saleOtherCountry', // 海外其它销售 三级页面 获取国家销量、批发量、库存明细信息 //海外库存二级 获取其他市场详情
    getZkcKljgTableData: HOST + 'sl/totalInvCarSeries', // 中国库销比饼图下钻三级页面，总库存车系表格
    getJxsKljgSfTableData: HOST + 'sl/provinceInvCarSeries', // 中国库销比饼图下钻三级页面，经销商省份表格
    getJxsKljgCsTableData: HOST + 'sl/cityInvCarSeries', // 中国库销比饼图下钻三级页面，经销商城市表格
    getJxsKljgCxTableData: HOST + 'sl/dealerInvCarSeries', // 中国库销比饼图下钻三级页面，经销商车系表格
    getKcThirdSfCityTable: HOST + 'sl/saleCarSeriesCity', // 获取经销商库存三级页面，省份城市数据
    getKcThirdSfCxTable: HOST + 'sl/saleProvinceCarSeries', // 获取经销商库存三级页面，省份车系数据
    getKcThirdCxTable: HOST + 'sl/saleProvince', // 获取经销商库存三级页面，车系数据
    getKcThirdSfCityJxsTable: HOST + 'sl/saleCityDealerName', // 获取经销商库存三级页面，省份城市下经销商的数据
    getKcThirdCxJxsTable: HOST + 'sl/saleCarSeriesCity', // 获取经销商库存三级页面，车系下的经销商数据
    getSzlSecondPpTableData: HOST + 'sl/tradeCompCarBrand', // 获取市占率二级页面，品牌表格数据
    getSzlSecondCxTableData: HOST + 'sl/tradeCompCarSeries', // 获取市占率二级页面，品牌表格数据
    getSaleSecondInDetailData: HOST + 'sl/saleCarBrand', // 获取国内销售，批售 二级页面数据
    getSaleSecondInBarData: HOST + 'sl/saleTrade', // 获取国内销售，批售 三级页面趋势图数据
    getSaleSecondInSfTableData: HOST + 'sl/saleProvince', // 获取国内销售，批售 三级页面省份表格数据
    getSaleSecondInCxTableData: HOST + 'sl/saleCarSeries', // 获取国内销售，批售 三级页面车系表格数据
    getSaleThirdCxFirstLevelTable: HOST + 'sl/saleProvince', // 获取国内销售，批售 四级页面，车系表格第一层
    getSaleThirdCxSecondLevelTable: HOST + 'sl/saleCarSeriesCity', // 获取国内销售，批售 四级页面，车系表格第二层
    getSaleThirdSfCsFirstLevelTable: HOST + 'sl/saleCarSeriesCity', // 获取国内销售，批售 四级页面，省份城市表格第一层
    getSaleThirdSfCsSecondLevelTable: HOST + 'sl/saleCityDealerName', // 获取国内销售，批售 四级页面，省份城市第二层
    getSaleThirdSfCxSecondLevelTable: HOST + 'sl/saleProvinceCarSeries', // 获取国内销售，批售 四级页面，省份车系第一层
    getSaleAbroadDealer: HOST + 'sl/saleAbroadDealer', // 获取海外国家经销商库存信息
    getKeyWarn: HOST + 'sl/getKeyWarn', // 获取预警
    getHomePageWarn: HOST + 'sl/homePageWarn' // 获取首页预警
  },
  news: {
    getAllSubType: HOST + 'newsApi/getAllSubType', // 获取新闻分类
    getNewsList: HOST + 'newsApi/getAllNewsListByPage', // 获取新闻列表
    getNewsDetail: HOST + 'newsApi/getNewsContentById', // 获取新闻详情
    submitCommet: HOST + 'newsApi/addComment', // 提交评论
    getCommetList: HOST + 'newsApi/commentListByNewsId', // 获取评论列表
    submitZan: HOST + 'newsApi/addParise', // 点赞操作
    submitRead: HOST + 'newsApi/addRead' // 已读操作
  },
  rb: {
    getBattleGroupBrand: HOST + 'battleRedBlackListApi/getBattleGroupBrand', // 红黑榜作战群
    getCompanySale: HOST + 'battleRedBlackListApi/getCompanySale', // 作战群集团整体
    getBattleUnitSeries: HOST + 'battleRedBlackListApi/getBattleUnitSeries' // 作战单元

  },
  // 用户运营排行榜
  userRunRanking: {
    getBrandList: HOST + 'rankApi/getBrandList',
    getCombatUnitInfo: HOST + 'rankApi/getCombatUnitInfo',
    getUnitStatisList: HOST + 'rankApi/getUnitStatisList',
    getUnitDetail: HOST + 'rankApi/getUnitDetail',
    getUnitDetailList: HOST + 'rankApi/getUnitDetailList',
    getServiceRankInfo: HOST + 'rankApi/getServiceRankInfo',
    getServiceStatisList: HOST + 'rankApi/getServiceStatisList',
  }
}

export default API
